"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Conditional = void 0;
class Conditional {
    constructor(checkValue, childRenderer) {
        this.checkValue = checkValue;
        this.childRenderer = childRenderer;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    format(value, parameter) {
        return Boolean(value) === this.checkValue ? this.childRenderer.default(parameter) : '';
    }
}
exports.Conditional = Conditional;
//# sourceMappingURL=conditional.js.map